
import {createSlice} from "@reduxjs/toolkit";

export const contractSearchSlice = createSlice({
    name: 'contractSearchSlc',
    initialState: {value: {
            id: null,
            idFrom: null,
            idTo: null,
            mcode: null,
            name: null,
            contractType: null,
            createdOn: null,
            createdFrom: null,
            createdTo: null,
            contractSearchGridRefresh: false,
            searchState: true,
            gridState: false,
        }},
    reducers:

        {
            changeContractSearch: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeContractSearch } = contractSearchSlice.actions;

export default  contractSearchSlice.reducer ;
